import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  DraftAccount = 'DraftAccount',
  DocumentMetadata = 'DocumentMetadata',
  Disclosures = 'Disclosures',
}

export const queryKeys = {
  draftAccount: (clientId: string, draftId: string) => [
    QueryFeature.AccountOpening,
    QueryKey.DraftAccount,
    clientId,
    draftId,
  ],

  documentMetadata: (clientId: string, draftId: string, snapId?: string) => [
    QueryFeature.AccountOpening,
    QueryKey.DocumentMetadata,
    clientId,
    draftId,
    snapId,
  ],

  disclosures: (clientId: string, draftId: string) => [
    QueryFeature.AccountOpening,
    QueryKey.Disclosures,
    clientId,
    draftId,
  ],
};
